import deepmerge from "deepmerge";
import { SpecialEvent, SpecialEvents } from "./types";

const deepClean = <T>(obj: T): Partial<T> => {
  const isObject = (value: unknown | T) =>
    Object.prototype.toString.call(value) === Object.prototype.toString.call({});
  const isEmptyObject = (value: unknown | T) =>
    isObject(value) && Object.keys(value as T).length === 0;
  const isEmptyValue = (value: unknown) => value === null || value === "";
  const mustBeDeleted = (value: unknown | T) => isEmptyValue(value) || isEmptyObject(value);

  if (!isObject(obj)) throw new Error("Input parameter must be an object");

  const clean = (copy: T) =>
    Object.keys(copy).reduce((acc, key) => {
      let value = copy[key];
      if (isObject(value) && !isEmptyObject(value)) {
        value = clean(value as T);
      }
      if (!mustBeDeleted(value)) {
        acc[key] = value;
      }
      return acc;
    }, {} as T);

  return clean(obj);
};

const inRangeDates = (publish: Date, unpublish: Date): boolean => {
  const publishTs = publish.getTime();
  const unpublishTs = unpublish.getTime();
  if (isNaN(publishTs) || isNaN(unpublishTs)) {
    return false;
  }

  const current = new Date().getTime();
  return Boolean(current >= publishTs && current < unpublishTs);
};

const toDate = (...args: string[]) => args.map(date => new Date(date));

export const mergePromotion = (specialEvents: SpecialEvents): SpecialEvent =>
  (specialEvents || []).reduce((promotion, event) => {
    const { publishDate: publishDateString, unpublishDate: unpublishDateString } = event;
    const [publishDate, unpublishDate] = toDate(publishDateString, unpublishDateString);

    if (!inRangeDates(publishDate, unpublishDate)) {
      return promotion;
    }

    return deepmerge(promotion, deepClean<SpecialEvent>(event));
  }, {});
